import React from 'react';
import { Button } from '@mentimeter/ragnar-ui/button';
import { Text } from '@mentimeter/ragnar-ui/text';
import {
  PopoverRoot,
  PopoverContainer,
  PopoverBody,
  PopoverAnchor,
} from '@mentimeter/ragnar-ui/popover';
import { Box } from '@mentimeter/ragnar-ui/box';
import { clsx } from '@mentimeter/ragnar-tailwind-config';
import { TOUR_LENGTH } from '../hooks/use-tour-store';
import './tour-popover-animate.css';

export interface TourPopoverProps {
  show: boolean;
  currentStep: number;
  totalSteps?: number;
  title: string;
  description: string;
  onNext?: (() => void) | undefined;
  side?: 'top' | 'right' | 'bottom' | 'left';
  arrowIllustration?: React.ReactNode;
  align?: 'start' | 'center' | 'end';
  triggerRef: React.RefObject<HTMLElement>;
  animate?: boolean;
}

export const TourPopover: React.FC<TourPopoverProps> = ({
  show,
  currentStep,
  totalSteps = TOUR_LENGTH,
  title,
  description,
  onNext,
  side = 'right',
  align = 'center',
  arrowIllustration,
  triggerRef,
  animate = false,
}) => {
  return (
    <PopoverRoot open={show}>
      <PopoverAnchor virtualRef={triggerRef} />
      <PopoverContainer
        // Figure out how to style the arrow change size and color, decide if we want to invest time in this, or rather hide it
        showArrow={true}
        borderRadius="xl"
        align={align}
        side={side}
        width={300}
        height="100%"
        className={clsx(
          'dark',
          'tour-popover-container',
          animate && 'tour-popover-animation',
        )}
      >
        <PopoverBody
          px="space6"
          py="space8"
          height="100%"
          flexDirection="column"
          justifyContent="space-between"
        >
          <Box flex="1" justifyContent="center" alignItems="center" mb="space8">
            {arrowIllustration}
          </Box>
          <Box flexDirection="column" gap="space4">
            <Text color="onBrand" variant="contentHero4" fontSize="300">
              {title}
            </Text>
            <Text color="onDisabledStrong" variant="editorBodyMd">
              {description}
            </Text>
          </Box>
          <Box
            width="100%"
            justifyContent="space-between"
            flexDirection="row"
            pt="space6"
          >
            <Text color="onBrand" variant="editorBodyMd">
              {/* Add i18n */}
              {currentStep} of {totalSteps}
            </Text>
            <Button variant="tertiary" onClick={onNext}>
              {/* Add i18n */}
              Next
            </Button>
          </Box>
        </PopoverBody>
      </PopoverContainer>
    </PopoverRoot>
  );
};
